import * as actions from './inventoryStockCheck/actions'
import * as mutations from './inventoryStockCheck/mutations'
import * as getters from './inventoryStockCheck/getters'

import { dataProps } from './inventoryStockCheck/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '', 
search_term_array: []
    },
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryStockCheck.js